<template>
	<section class="bg-white mx-content py-10 will-change" :data-scroll-section="inner == 'false'">
		<div class="mb-12">
            <h2 class="text-4xl xl:text-title leading-none mb-7" v-show="blockData.title">{{ blockData.title }}</h2>
        </div>

		<!-- map -->
		<div class="h-[67vh]">
		<div id="map" class="rounded-lg" style="height: 100%;"></div>
		</div>
		<!-- map -->
		<div class="absolute bottom-14 left-1/2 -translate-x-1/2 bg-white bg-opacity-90 rounded text-xs text-center px-10 py-5 whitespace-nowrap">
			<span>{{ __('Click on the interest point or zoom in to view more', 'ccave') }}</span>
		</div>

	</section>
</template>

<script>
import mapboxgl from "mapbox-gl";

export default {
	name: "BasicMap",
	data() {
		return {
			map: false,
		}
	},
	mounted() {

		mapboxgl.accessToken = this.blockData.map.map_settings.access_token;
		this.map = new mapboxgl.Map({
			container: "map", // container ID
			style: 'mapbox://styles/aleksandarstojsin/ckxreflet1y4v14pptbu6meh1', // style URL
			center: this.blockData.map.map_settings.center, // starting position
			zoom: this.blockData.map.map_settings.zoom, // starting zoom
			pitch: this.blockData.map.map_settings.pitch,
			bearing: this.blockData.map.map_settings.bearing,
			cooperativeGestures: true,
            attributionControl: false
		});

		this.map.addControl(new mapboxgl.NavigationControl());
		this.map.scrollZoom.disable();
	},
	methods: {
	}
};
</script>

<style scoped>
.map {
	position: absolute;
	left: 33.3333%;
	width: 66.6666%;
	top: 0;
	bottom: 0;
}

</style>
